import {CardViewMoreItem} from '../../../../design-system/organisms/CardViewMoreItem/CardViewMoreItem';
import {MoreItem} from '../../../../graphql/generated/types';
import {CommonItemProps} from '../../type';

export function More({item}: CommonItemProps) {
  const {isPosterView, title, scheme} = item as MoreItem;
  return (
    <CardViewMoreItem
      title={title || undefined}
      isPosterView={isPosterView}
      scheme={scheme}
    />
  );
}
